<template>
  <div class="action-icon__wrapper">
    <component :is="actionIcon" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'

export const ACTION_ICON = {
  SAVE: 'SaveForLater',
  FOLLOW: 'FollowTag',
  SHARE: 'Share',
  LINKED_IN: 'LinkedIn',
  TWITTER: 'Twitter',
  TELEGRAM: 'Telegram',
  FACEBOOK: 'Facebook',
  WHATSAPP: 'WhatsApp',
  REDDIT: 'Reddit',
  EMAIL: 'Email',
  FM_COMMENT_COUNT: 'FmCommentCount',
  IL_COMMENT_COUNT: 'IlCommentCount',
  LEARN_ABOUT: 'LearnAboutTerm'
}

const ACTION_ICON_LIST = Object.values(ACTION_ICON)

export default {
  name: 'AActionIcon',
  inheritAttrs: false,
  components: {
    SaveForLater: () => import('./SaveForLater'),
    FollowTag: () => import('./FollowTag'),
    LearnAboutTerm: () => import('./LearnAboutTerm'),
    Twitter: () => import('./Twitter'),
    Telegram: () => import('./Telegram'),
    Facebook: () => import('./Facebook'),
    WhatsApp: () => import('./WhatsApp'),
    LinkedIn: () => import('./LinkedIn'),
    Reddit: () => import('./Reddit'),
    Email: () => import('./Email'),
    FmCommentCount: () => import('./FmCommentCount'),
    IlCommentCount: () => import('./IlCommentCount'),
    Share: () => import('./Share')
  },
  props: {
    actionIcon: propValidator([PROP_TYPES.STRING], true, null, prop =>
      ACTION_ICON_LIST.includes(prop)
    )
  }
}
</script>

<style lang="scss" scoped>
.action-icon__wrapper {
  & > a {
    // to make sure the focus outline is visible
    display: flex;
  }
}
</style>
